<template>
    <div class="petetion__details_page" :class="{ 'anonymouslogin': !checkCurrentUrl}">
    <template v-if="!checkCurrentUrl && accessError">
      <verifierActionInfo :accessError="accessError" :tenantName="tenantName"  />
    </template>
    <template v-else>
      <div class="tabs-layout-header cpr_heading">
        <div class="case-no-panel i9-details_header"  v-if="!loadedFromPreview">
           <div class="casenumber_sec ">
            <div class="case_number">
            <div class="d-flex align-items-center">
              Employee
              <em
                class="edit_caseno"
                v-if="!loadedFromPreview &&   [3, 4, 5].indexOf(getUserRoleId) > -1&&false"
                v-on:click.stop.prevent="editCaseNumber"
              >
                <img src="@/assets/images/main/edit_icon.svg" />
              </em>
            </div>
            <span>{{ checkProperty(caseDetails,"beneficiaryDetails","name") }} </span>
            <i
              class="material-icons"
              v-if="
                !loadedFromPreview &&
                checkCurrentUrl &&
                checkProperty(petitions, 'length') > 0&&false
              "
              >arrow_drop_down</i
            >
          </div>
          <div
            class="case_number_list"
            v-if="
              !loadedFromPreview &&
              checkCurrentUrl &&
              checkProperty(petitions, 'length') > 0&&false
            "
          >
            <VuePerfectScrollbar class="scroll-area">
              <ul v-if="petitions">
                <li
                  @click="showDetails(caseDetails)"
                  v-for="(petition, index) in petitions"
                  :key="index"
                >
                  {{ petition.caseNo }}
                </li>
              </ul>
            </VuePerfectScrollbar>
          </div>
              <div class="case_number" v-if="false">
                 <div class="d-flex align-items-center" v-if="checkProperty(caseDetails, 'customId')">
                  {{"Case No"}}
                 </div>
                 <span>{{checkProperty(caseDetails, 'customId')}}
                 </span>
                  <!-- <i class="material-icons"
                    v-if="!loadedFromPreview && checkCurrentUrl && checkProperty(petitions, 'length') > 0">arrow_drop_down</i> -->
              </div>
              <div class="i9_head_right">
                <div class="i9_details_actions verifiyer_action" >
                  <template v-if="checkProperty(caseDetails, 'verifierInfo', 'name') && checkProperty(caseDetails, 'completedActivities', 'length') > 0 &&caseDetails.completedActivities.indexOf('ASSIGNED_VERIFIER') > -1 ">
                        <div class="selected_list" v-if="checkProperty(caseDetails, 'verifierInfo')">   
                            <div class="selected_item" >
                                <!-- <span class="dp">
                                  <avatar :size="36" :backgroundColor="'#fff'"  :initials="avtarName(caseDetails, 'verifierInfo','name')"></avatar>
                                </span> -->
                                <div class="list_info v2">
                                    <div class="sign_title">
                                        <p>Verifier</p>

                                    </div>
                                    <span class="email" v-if="checkProperty(caseDetails, 'verifierInfo','name')">
                                        {{ checkProperty(caseDetails,'verifierInfo', 'name') }}
                                    
                                    <span class="ml-1 verifier_info_icon" v-if="checkProperty(caseDetails,'verifierInfo', 'email') && !((checkProperty(caseInfo, 'action')==='I9_FORM_REJECTED'  || checkProperty(caseInfo, 'action')=== 'I9_FORM_APPROVED') && ([4,5,6,8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))>-1))">
                                          <!-- <info-icon size="1.5x" class="custom-class"></info-icon> -->
                                           <img src="@/assets/images/icons/info_btn.png" />
                                           <div class="verify_message">
                                          <div class="vx-row m-0 main-list-panel">
                                            <div class="vx-col md:w-full w-full p-0">
                                            <div class="main-list"> 
                                            <p>
                                              Email
                                              <span>{{ checkProperty(caseDetails,'verifierInfo', 'email') }}</span>
                                            </p>
                                            </div>
                                          </div>
                                          <div class="vx-col md:w-1/2 w-full p-0">
                                              <div class="main-list"> 
                                              <p>
                                                Phone Number
                                                <span>{{ checkProperty(caseDetails['verifierInfo'], 'phoneCountryCode','countryCallingCode')+' '+checkProperty(caseDetails['verifierInfo'], 'phone') }}</span>
                                              </p>
                                              </div>
                                            </div>   
                                      </div>                         
                                     </div>
                                    </span>
                              </span>
                                   
                                <template v-if="(checkProperty(caseDetails, 'questionnaireFilled') && (checkProperty(caseDetails, 'completedActivities', 'length') > 0 && caseDetails.completedActivities.indexOf('VERIFIER_REJECTED')>-1) && (checkProperty(caseDetails, 'verifierRejected') && ([5,6,7].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))>-1)))
                                  && ((
                                  ([3, 4].indexOf(getUserRoleId) > -1 && getTenantTypeId != 1) || 
                                  ((checkProperty(caseDetails, 'createdBy') == checkProperty(getUserData, 'userId')) && getTenantTypeId != 1) || 
                                  ([50].indexOf(getUserRoleId) > -1 && getTenantTypeId == 1 || (checkProperty(caseDetails, 'createdBy') == checkProperty(getUserData, 'userId')) && getTenantTypeId == 2)
                                  ) &&checkProperty(caseDetails, 'completedActivities','length') > 0 && caseDetails.completedActivities.indexOf('APPROVED') > -1) 
                                  && checkProperty(caseDetails, 'status')==true">
                                  <!-- <button @click="editVerifier()">Change Verifier</button> -->
                                  
                                  <a class="text_link" v-if="checkProperty(getUserData, 'userId') == checkProperty(caseDetails, 'verifierInfo','_id')" @click="reAssignToMe()">I will do it</a>
                                  <a class="text_link" v-else @click="reAssign()">Request to verify</a>
                                </template>
                                </div>
                                <template v-if="(checkProperty(caseDetails, 'questionnaireFilled') && (checkProperty(caseDetails, 'completedActivities', 'length') > 0 && caseDetails.completedActivities.indexOf('VERIFIER_REJECTED')>-1) && (checkProperty(caseDetails, 'verifierRejected') && ([5,6,7].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))>-1)))
                                  && ((
                                  ([3, 4].indexOf(getUserRoleId) > -1 && getTenantTypeId != 1) || 
                                  ((checkProperty(caseDetails, 'createdBy') == checkProperty(getUserData, 'userId')) && getTenantTypeId != 1) || 
                                  ([50].indexOf(getUserRoleId) > -1 && getTenantTypeId == 1 || (checkProperty(caseDetails, 'createdBy') == checkProperty(getUserData, 'userId')) && getTenantTypeId == 2)
                                  ) &&checkProperty(caseDetails, 'completedActivities','length') > 0 && caseDetails.completedActivities.indexOf('APPROVED') > -1)
                                  && checkProperty(caseDetails, 'status')==true ">
                                  <div class="IB_tooltip placement-right ml-0 mr-3 cursor" @click="editVerifier()" >
                                    <em>
                                      <img src="@/assets/images/main/icon-edit.svg" />
                                    </em>
                                    <div class="tooltip_cnt nowrap">
                                    <p>
                                      Change Verifier
                                    </p>
                                    </div>
                                  </div>
                              </template>
                             
                                <span class="verify_message_icon">
                                    <template v-if="(checkProperty(caseInfo, 'action')==='I9_FORM_REJECTED'  || checkProperty(caseInfo, 'action')=== 'I9_FORM_APPROVED') && ([2,4,5,6,8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))>-1)">    
                                      <svg xmlns="http://www.w3.org/2000/svg" width="27.001" height="24.844" viewBox="0 0 27.001 24.844">
                                      <path id="Union_64" data-name="Union 64" d="M-9986.863-20407.395h-1.01a3.741,3.741,0,0,1-3.737-3.738v-12a3.743,3.743,0,0,1,3.737-3.738h19.526a3.742,3.742,0,0,1,3.737,3.738v3.266h-.071v8.734a3.741,3.741,0,0,1-3.737,3.738h-10.433l-8.013,5.367Zm3.179-6.449h11.565v-1.877h-11.565Zm0-4.543h11.565v-1.875h-11.565Z" transform="translate(9991.61 20426.871)" fill="#C69942"/>
                                    </svg>
                                  </template>
                                <div class="verify_message">
                                    <div class="vx-row m-0 main-list-panel">
                                      <template v-if="checkProperty(caseInfo, 'action')">
                                        <div class="vx-col md:w-1/2 w-full p-0">
                                          <div class="main-list">                                                                                 
                                          <p>Activity
                                            <template v-if="checkProperty(caseInfo, 'action') == 'I9_FORM_APPROVED'">
                                              <span><svg id="check" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                                                <g id="Group_8119" data-name="Group 8119">
                                                  <path id="Path_34467" data-name="Path 34467" d="M6,0a6,6,0,1,0,6,6A6.023,6.023,0,0,0,6,0ZM5.274,8.729,2.646,6.1l.994-.994L5.32,6.787,8.691,3.722l.946,1.04Z" fill="#5aba6c"/>
                                                </g>
                                              </svg>
                                              Approved</span>
                                            </template>
                                            <template v-if="checkProperty(caseInfo, 'action') == 'I9_FORM_REJECTED'">
                                              <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="12" height="12"> 
                                                  <path id="close" fill="#e50019" class="cls-1" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.384,13.748a.453.453,0,0,1-.64.64L10,10.64,6.252,14.388a.453.453,0,0,1-.64-.64L9.36,10,5.612,6.252a.453.453,0,0,1,.64-.64L10,9.36l3.748-3.748a.453.453,0,0,1,.64.64L10.64,10Z"/>
                                                </svg>
                                                Rejected</span>
                                            </template>
                                          </p>
                                          </div>
                                        </div>
                                      </template>
                                      <div class="vx-col md:w-1/2 w-full p-0">
                                          <div class="main-list">
                                            <p>IP Address
                                              <span>
                                                {{ checkProperty(caseInfo, 'ipInfo', 'ip') || 'NA' }}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                  <!-- <template v-if="checkProperty(petitionhistory[0], 'deviceInfo') && checkProperty(petitionhistory[0].deviceInfo, 'device') &&checkProperty(petitionhistory[0].deviceInfo, 'device', 'type') && checkProperty(petitionhistory[0].deviceInfo, 'device', 'vendor')"> -->
                                    <div class="vx-col md:w-1/2 w-full p-0">
                                        <div class="main-list">                                     
                                        <p>Device
                                          <span>
                                            <template v-if="checkProperty(caseInfo, 'deviceInfo') && checkProperty(caseInfo.deviceInfo, 'device', 'type')">
                                              {{ checkProperty(caseInfo.deviceInfo, 'device', 'type')}}
                                            </template>
                                            <template v-else>{{ 'PC' }}</template>
                                          </span>
                                        </p>
                                        </div>
                                      </div>
                                    <!-- </template> -->
                                      <template v-if="checkProperty(caseInfo, 'createdOn')">
                                      <div class="vx-col md:w-1/2 w-full p-0">
                                        <div class="main-list"> 
                                        <p>
                                          Verified On
                                          <span>{{ checkProperty(caseInfo, 'createdOn') |formatDateTime  }}</span>
                                        </p>
                                        </div>
                                      </div>
                                    </template>
                                  <template v-if="checkProperty(caseInfo, 'deviceInfo', 'browser')">
                                    <div class="vx-col md:w-full w-full p-0">
                                      <div class="main-list">                                     
                                        <p>
                                          Browser
                                          <span>{{ `${checkProperty(caseInfo.deviceInfo, 'browser', 'name')}`}} {{`(${checkProperty(caseInfo.deviceInfo, 'browser', 'version')})`}}
                                            - {{`${checkProperty(caseInfo.deviceInfo, 'os', 'name')}`}} {{`${checkProperty(caseInfo.deviceInfo, 'os', 'version')}`}}
                                          </span>
                                        </p>
                                      </div>
                                      </div>
                                    </template>
                                      <template v-if="checkProperty(caseInfo, 'ipInfo', 'country')">
                                      <div class="vx-col md:w-1/2 w-full p-0">
                                        <div class="main-list"> 
                                        <p>
                                          Location
                                          <span>{{ checkProperty(caseInfo, 'ipInfo', 'country') }}</span>
                                        </p>
                                        </div>
                                      </div>
                                    </template>
                                <template v-if="checkProperty(caseDetails, 'verifierDetails') || checkProperty(caseDetails, 'verifierInfo')">
                                 <template v-if="checkProperty(caseDetails, 'verifierInfo', 'name' ) || checkProperty(caseDetails,'verifierDetails', 'firstName') && checkProperty(caseDetails,'verifierDetails', 'lastName')">
                                 <h4>Verifier Information</h4>
                                  <div class="vx-col md:w-1/2 w-full p-0">
                                    <div class="main-list">                                     
                                      <p>
                                        Name
                                        <template v-if="checkProperty(caseDetails,'verifierInfo','name')">
                                          <span>{{ checkProperty(caseDetails,'verifierInfo','name') }}</span>
                                        </template>
                                        <template v-else>
                                          <span>{{ `${caseDetails['verifierDetails']['firstName']}` + ` ${caseDetails['verifierDetails']['lastName']}`}}</span>
                                        </template>
                                      </p>
                                    </div>
                                    </div>
                                  </template>  
                                  <template v-if="checkProperty(caseDetails,'verifierInfo', 'phone') && checkProperty(caseDetails['verifierInfo'] ,'phoneCountryCode' ,'countryCallingCode')">
                                    <div class="vx-col md:w-1/2 w-full p-0">
                                      <div class="main-list"> 
                                      <p>
                                        Phone Number
                                        <span>{{ checkProperty(caseDetails['verifierInfo'], 'phoneCountryCode','countryCallingCode')+' '+checkProperty(caseDetails['verifierInfo'], 'phone') }}</span>
                                      </p>
                                      </div>
                                    </div>
                                  </template>
                                  <template v-if="checkProperty(caseDetails,'verifierInfo', 'email')">
                                    <div class="vx-col md:w-full w-full p-0">
                                      <div class="main-list"> 
                                      <p>
                                        Email
                                        <span>{{ checkProperty(caseDetails,'verifierInfo', 'email') }}</span>
                                      </p>
                                      </div>
                                    </div>
                                  </template>
                                    <div class="vx-col w-full p-0">
                                      <div class="main-list"> 
                                        <template v-if=" checkProperty(caseDetails['verifierDetails'] ,'address' )&&(
                                          checkProperty(caseDetails['verifierDetails'] ,'address' ,'line1' )
                                          || checkProperty(caseDetails['verifierDetails']['address'] ,'locationDetails' ,'name' )
                                          || checkProperty(caseDetails['verifierDetails']['address'] ,'stateDetails' ,'name' )
                                          || checkProperty(caseDetails['verifierDetails']['address'] ,'countryDetails' ,'name' ))">
                                          <div class="list-info">
                                            <p>Address
                                              <span v-html="$options.filters.addressformat(caseDetails.verifierDetails.address)"></span>
                                            </p>
                                            
                                          </div>
                                        </template>
                                        <template v-else>
                                          <template v-if="checkProperty(caseDetails, 'verifierInfo', 'address')">
                                          <div class="list-info">
                                            <p>Address
                                              <span v-html="$options.filters.addressformat(caseDetails.verifierInfo.address)"></span>
                                            </p>
                                            
                                          </div>
                                        </template>
                                        </template>
                                      </div>
                                    </div> 
                                    <template v-if="checkProperty(caseDetails['verifierDetails'],'identifyDoc','length')>0">
                                    <div class="vx-col w-full p-0">
                                    <div class="main-list  mb-0">
                                      <div class="list-info">
                                        <p>Identify Documents</p>
                                        <vs-col class="padl0 padr0" v-if="checkProperty(caseDetails['verifierDetails'],'identifyDoc','length')>0" >
                                        <documentsView @download_or_view="download_or_view" :showTitle="false" :label="'Documents'"  :documentsList="caseDetails['verifierDetails']['identifyDoc']" />
                                      </vs-col>
                                       </div>
                                      <!-- <h4>Employee Signed I-9 Form<button v-if="checkSignButton" class="IB_primary-btn"  @click="generateSignedUrl()">Sign</button></h4> -->     
                                    </div>   
                                  </div>                             
                                </template>
                              </template>    
                              </div>                         
                              </div>
                           </span>
                               
                           <!-- <button @click="editVerifier()">Change Verifier</button> -->
                            </div>
                        </div>
                    </template>
                    <template v-if="checkProperty(caseDetails, 'authSignerInfo', 'name') && checkProperty(caseDetails, 'completedActivities', 'length') > 0 &&caseDetails.completedActivities.indexOf('ASSIGNED_SIGNER') > -1">
                        <div class="selected_list" v-if="checkProperty(caseDetails, 'authSignerInfo')">   
                            <div class="selected_item" >
                                <!-- <span class="dp">
                                    <avatar :size="36" :backgroundColor="'#fff'" :initials="avtarName(caseDetails,'authSignerInfo','name')"></avatar>
                                </span> -->
                                <div class="list_info v2">
                                    <div class="sign_title">
                                        <p>Authorized Signatory</p>
                                    </div>
                                    <span class="email" v-if="checkProperty(caseDetails, 'authSignerInfo','name')">
                                        {{ checkProperty(caseDetails,'authSignerInfo', 'name') }} 
                                          <span class="ml-1 verifier_info_icon" v-if="checkProperty(caseDetails,'authSignerInfo', 'email')">
                                           <img src="@/assets/images/icons/info_btn.png" />
                                           <div class="verify_message">
                                          <div class="vx-row m-0 main-list-panel">
                                            <div class="vx-col md:w-full w-full p-0">
                                            <div class="main-list"> 
                                            <p>
                                              Email
                                              <span>{{ checkProperty(caseDetails,'authSignerInfo', 'email') }}</span>
                                            </p>
                                            </div>
                                          </div>
                                          <div class="vx-col md:w-1/2 w-full p-0">
                                              <div class="main-list"> 
                                              <p>
                                                Phone Number
                                                <span>{{ checkProperty(caseDetails['authSignerInfo'], 'phoneCountryCode','countryCallingCode')+' '+checkProperty(caseDetails['authSignerInfo'], 'phone') }}</span>
                                              </p>
                                              </div>
                                            </div>   
                                      </div>                         
                                     </div>
                                      </span>
                                  
                                    </span>
                                </div>
                                <template v-if="(checkProperty(caseDetails, 'questionnaireFilled') && (checkProperty(caseDetails, 'completedActivities', 'length') > 0 && caseDetails.completedActivities.indexOf('VERIFIER_REJECTED')>-1) && (checkProperty(caseDetails, 'verifierRejected') && ([5,6,7].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))>-1)))
                                  && ((
                                  ([3, 4].indexOf(getUserRoleId) > -1 && getTenantTypeId != 1) || 
                                  ((checkProperty(caseDetails, 'createdBy') == checkProperty(getUserData, 'userId')) && getTenantTypeId != 1) || 
                                  ([50].indexOf(getUserRoleId) > -1 && getTenantTypeId == 1 || (checkProperty(caseDetails, 'createdBy') == checkProperty(getUserData, 'userId')) && getTenantTypeId == 2)
                                  ) &&checkProperty(caseDetails, 'completedActivities','length') > 0 && caseDetails.completedActivities.indexOf('APPROVED') > -1)
                                  && checkProperty(caseDetails, 'status')==true ">
                                  <!-- <button @click="editAuthSign()">Edit</button> -->
                                  <div class="IB_tooltip placement-right cursor"  @click="editAuthSign()" >
                                    <em>
                                      <img src="@/assets/images/main/icon-edit.svg" />
                                    </em>
                                    <div class="tooltip_cnt">
                                    <p>
                                     Change Signatory
                                    </p>
                                    </div>
                                  </div>  
                                </template>
                            </div>
                        </div>
                    </template>
                    <ul class="items-list">
                      <!-- <li  v-if="[51].indexOf(getUserRoleId)<=-1" class="tabwidth">
                        Employee
                        <span style="font-size:12px">{{ checkProperty(caseDetails,"beneficiaryDetails","name") }}</span>
                      </li> -->
                      <li v-if="checkProperty(caseDetails,'petitionerId') && checkProperty(caseDetails,'petitionerDetails','name') && getTenantTypeId !=2 && [51].indexOf(getUserRoleId)<=-1" class="tabwidth">
                        Employer
                        <span style="font-size:12px">{{ checkProperty(caseDetails,"petitionerDetails","name") }}</span>
                      </li>
                    </ul>
                  <template  v-if="checkProperty(caseDetails, 'status')==true &&
                  (
                    ([3, 4].indexOf(getUserRoleId) > -1 && getTenantTypeId != 1) || 
                    ((checkProperty(caseDetails, 'createdBy') == checkProperty(getUserData, 'userId')) && getTenantTypeId != 1) || 
                    ([50].indexOf(getUserRoleId) > -1 && getTenantTypeId == 1 || (checkProperty(caseDetails, 'createdBy') == checkProperty(getUserData, 'userId')) && getTenantTypeId == 2)
                  ) &&checkProperty(caseDetails, 'completedActivities','length') > 0 && caseDetails.completedActivities.indexOf('APPROVED') > -1">
                      <a class="IB_primary-btn" @click="requestAuthSign()" v-if="caseDetails.completedActivities.indexOf('ASSIGNED_SIGNER') <= -1">Assign Authorized Signatory</a>
                      <a class="IB_primary-btn" @click="assignVerifier()" v-if="caseDetails.completedActivities.indexOf('ASSIGNED_VERIFIER') <= -1 && caseDetails.completedActivities.indexOf('ASSIGNED_SIGNER') >-1">Assign Verifier</a>  
                  </template>
                </div>
                <div class="d-flex align-center">
                  <a class="IB_primary-btn" v-if="[51,49].indexOf(getUserRoleId)<=-1 && checkCurrentUrl && (this.checkProperty(caseDetails, 'completedActivities', 'length') > 0
                  &&caseDetails.completedActivities.indexOf('WAITING_FOR_EMPLOYEE_SIGN') >-1||this.checkProperty(caseDetails, 'questionnaireFilled'))" @click="openAuditTrail()" >I-9 Audit Trail</a>
                
                <template v-if="(checkProperty(caseInfo, 'action') == 'I9_FORM_REJECTED'||checkProperty(caseInfo, 'action') == 'I9_FORM_APPROVED') && checkProperty(caseInfo, 'comment')">
                  <div class="message_notifications">
                      <template v-if="checkProperty(caseInfo, 'comment')">    
                        <svg xmlns="http://www.w3.org/2000/svg" width="27.001" height="24.844" viewBox="0 0 27.001 24.844">
                          <path id="Union_64" data-name="Union 64" d="M-9986.863-20407.395h-1.01a3.741,3.741,0,0,1-3.737-3.738v-12a3.743,3.743,0,0,1,3.737-3.738h19.526a3.742,3.742,0,0,1,3.737,3.738v3.266h-.071v8.734a3.741,3.741,0,0,1-3.737,3.738h-10.433l-8.013,5.367Zm3.179-6.449h11.565v-1.877h-11.565Zm0-4.543h11.565v-1.875h-11.565Z" transform="translate(9991.61 20426.871)" fill="#0E1D48"/>
                        </svg>
                      </template>
                      <div class="notifications">
                        <template v-if="checkProperty(caseInfo, 'action') == 'I9_FORM_REJECTED'"> 
                            <div class="notifications_list">                                                                                 
                            <label>Reason for Rejecting: </label> 
                            <template v-if="checkProperty(caseInfo, 'comment')">
                              <p> {{ returnCommentText(caseInfo.comment) | commentSubString }}</p>
                              <!-- <p v-html="checkProperty(petitionhistory[0], 'comment')"></p> -->
                              <span v-if="checkProperty(caseInfo, 'comment', 'length') >45" style="cursor: pointer;"  class="view_more" @click="showHistoryComment(caseInfo)"> View More</span>
                            </template> 
                          </div>
                        </template>
                        <template v-if="checkProperty(caseInfo, 'action') == 'I9_FORM_APPROVED'"> 
                            <div class="notifications_list">                                                                                 
                            <label>Approval Comments: </label> 
                            <template v-if="checkProperty(caseInfo, 'comment')">
                              <!-- <p v-html="checkProperty(petitionhistory[0], 'comment')"></p> -->
                              <p> {{ returnCommentText(caseInfo.comment) | commentSubString }}</p>
                              <span v-if="checkProperty(caseInfo, 'comment', 'length') >45" style="cursor: pointer;"  class="view_more" @click="showHistoryComment(caseInfo)"> View More</span>
                            </template> 
                          </div>
                        </template>                          
                      </div>
                    </div>
                 </template>
				               
                  <label class="i9_status">
                  <span v-if ="checkProperty(caseDetails, 'status') != false" v-bind:class="{ [getI9CaseStatus(checkProperty(caseDetails, 'statusDetails', 'id'))]: true }">{{ checkProperty(caseDetails, 'statusDetails', 'name') }}</span>
                  <span v-else class="status_denied">{{ "Deleted" }}</span>
                </label>
                 
                  <I9ProcessFlow
                  v-if="checkActionsPermissions"
                  :caseDetails="caseDetails" @updatepetition="reloadDetails"/>
                </div>
              </div>
           </div>
        </div>
     </div>
     <!-- [8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))>-1 || -->
  <section 
  :class="(([51].indexOf(getUserRoleId) > -1 &&
    (checkProperty(caseDetails, 'verifierType') !== 'remote' || (checkProperty(caseDetails, 'verifierType') === 'remote' && !checkProperty(caseDetails, 'verifierDetails','firstName') && !checkIwillDoIt ) )) 
    || (([49].indexOf(getUserRoleId)>-1 || !checkCurrentUrl ) &&
    (checkProperty(caseDetails, 'verifierType') !== 'remote' || ([2,3,8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))>-1 && checkProperty(caseDetails, 'verifierType') === 'remote'))))?'petition__details_section i9_details':'petition__details_section i9_details has_rightbar'"
  >
  <div class="pd_left">
    <ul>
      <li :class="{ current_child: selectedTab === 'Basic Info'  }" @click="setCurrentTab('Basic Info')">
          <a>Section 1 </a>
       </li>
       <li :class="{ current_child: selectedTab === 'Documents'  }" @click="setCurrentTab('Documents')">
        <a>Section 2</a>
     </li>
    </ul>
  </div>
  <div class="pd_right petition__details_cnt">
    <div class="pd_right_cnt" >
      <div class="pd_right_cnt_in">
      <template v-if="selectedTab === 'Basic Info'">
        <!-- checkProperty(caseDetails, 'questionnaireFilled')  -->
        <template v-if="caseDetails && checkProperty(caseDetails, 'questionnaireFilled') ||  (checkProperty(caseDetails, 'completedActivities', 'length') > 0
        &&caseDetails.completedActivities.indexOf('WAITING_FOR_EMPLOYEE_SIGN') >-1)|| loadedFromPreview">
        <template v-if="[49].indexOf(getUserRoleId)>-1 || (!checkCurrentUrl && [50].indexOf(getUserRoleId)<=-1) ">
          <verifierDetails 
          v-if="selectedTab === 'Basic Info'"
          :caseDetails='caseDetails' @reloadPetition="reloadDetails"
          :i9Id="i9Id"
          />
        </template>
        <template v-else>
          <basicInfo 
          v-if="selectedTab === 'Basic Info'"
          :caseDetails='caseDetails' @reloadPetition="reloadDetails"
          :i9Id="i9Id" :ref="'basic_info'"
          />
        </template>
        
        </template>
        <div v-else class="no-activities q_not_submitted">
          <div class="q_not_submitted_cnt">
            <figure>
              <img src="@/assets/images/main/no-activity-img.png" />
            </figure>
            <h3>
              <template v-if="[51].indexOf(getUserRoleId)>-1">
                <template v-if="!loadedFromPreview">
                  <a style="cursor:pointer;" @click="editQuestionnaire(i9Id)">
                    Fill Questionnaire.</a>
                </template>
              </template>
              <template v-else>Questionnaire Not Submitted Yet</template>
            </h3>
          </div>
        </div>
      </template>
      <!-- checkProperty(caseDetails, 'questionnaireFilled')&& -->
      <template v-if="selectedTab === 'Documents'">
        <template v-if="checkProperty(caseDetails, 'questionnaireFilled') || (checkProperty(caseDetails, 'completedActivities', 'length') > 0
        &&caseDetails.completedActivities.indexOf('WAITING_FOR_EMPLOYEE_SIGN') >-1) || loadedFromPreview">
          <section2Documents 
            v-if="selectedTab === 'Documents'"
            :caseDetails='caseDetails' @reloadPetition="reloadDetails"
            :callFromVerifier="([49].indexOf(getUserRoleId)>-1 || (!checkCurrentUrl && [50].indexOf(getUserRoleId)<=-1))?true:false"
          />
        </template>
        <div v-else class="no-activities q_not_submitted">
          <div class="q_not_submitted_cnt">
            <figure>
              <img src="@/assets/images/main/no-activity-img.png" />
            </figure>
            <h3>
              <template v-if="[51].indexOf(getUserRoleId)>-1">
                <template v-if="!loadedFromPreview">
                  <a style="cursor:pointer;" @click="editQuestionnaire(i9Id)">
                    Fill Questionnaire.</a>
                </template>
              </template>
              <template v-else>Questionnaire Not Submitted Yet</template>
            </h3>
          </div>
        </div>
      </template>
      <div class="questionnaire_footer pb-5 has_terms" 
      v-if="!loadedFromPreview && 
      (meetingJoined || (checkProperty(caseDetails, 'videoCallDetails', 'phase') && checkProperty(caseDetails, 'videoCallDetails', 'phase') != '')) && 
      checkProperty(caseDetails, 'verifierType') === 'remote'
       && ([49].indexOf(getUserRoleId)>-1 || !checkCurrentUrl || checkPetitionerWillDo) && [4,5,6,8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))<=-1" >
         <form class="employee_documents_left"  data-vv-scope="Documentsform" @submit.prevent="" @keydown.enter.prevent="">
                  <vs-checkbox class="padl20" v-model="verifiedDocuments">
                    I have verified the documents uploaded against all originals over a video call. I have also seen the person live and confirm the identify.
                  </vs-checkbox> 
                  <div class=""> 
                      <input type="hidden" :name="'otherNames_houseHoldAnnualliabilities'" v-validate="'required'"  data-vv-as="Field"  v-model="getConfirmation">
                      <span v-show="errors.has( 'Documentsform'+'.otherNames_houseHoldAnnualliabilities')" class="text-danger text-sm pl-4">*Field is required</span>
                  </div>
          </form>     
      </div>
      <div class="questionnaire_footer ml-3 pb-2"
      v-if="!loadedFromPreview && 
      (meetingJoined || (checkProperty(caseDetails, 'videoCallDetails', 'phase') && checkProperty(caseDetails, 'videoCallDetails', 'phase') != '')) && 
      checkProperty(caseDetails, 'verifierType') === 'remote'
       && ([49].indexOf(getUserRoleId)>-1 || !checkCurrentUrl || checkPetitionerWillDo) && [4,5,6,8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))<=-1" >
        <button  class="IB_primary-btn" @click="checkApprvOrReject(true)">Approve</button>
            <button  class="secondary__btn" @click="checkApprvOrReject(false)">Reject</button>
      </div>
      </div>
      <template v-if="([50].indexOf(getUserRoleId)>-1 || ([3,4,5,6,7,8].indexOf(getUserRoleId)>-1&&getTenantTypeId==2) ) && checkProperty(caseDetails, 'verifierType') === 'remote'">
        <vs-col
          vs-type="flex"
          class="padr0 padl0 mob-right activies_list_wrap status_wrap"
          style="width: 350px; flex-direction: column"
          v-if="!loadedFromPreview && checkCurrentUrl"
        >
          <ul>
            <li class="ptstatusBar">
              <div class="status_activities" :class="{'status_activities_full':[8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))>-1}">
                <label @click="$store.commit('toggleCaseStatusTab', 'showActivities')"
                :class="{ 'active':  getCaseStatusTab === 'showActivities' }">Activities</label>
                <label @click="$store.commit('toggleCaseStatusTab', 'showMeetingDetails')"
                :class="{ 'active': getCaseStatusTab === 'showMeetingDetails' }">Meeting Details</label>
                <!-- v-if="[8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))<=-1" -->
              </div>
            </li>
          </ul>
          <div class="history-sidebar petition_history activies_list" v-show="getCaseStatusTab === 'showActivities'">
            <div class="vs-sidebar">
              <div class="petition_updated" v-if="petitionhistory.length == 0">
                Last Updated -
                {{ checkProperty(caseDetails, "updatedOn") | formatDateTime }}
              </div>
              <div class="petition_updated" v-if="petitionhistory.length > 0">
                Last Updated - {{ petitionhistory[0].createdOn | formatDateTime }}
              </div>

              <div class="vs-sidebar--items">
                <VuePerfectScrollbar class="scroll-area">
                  <div class="timeline-sidebar 2">
                    <ul>
                      <li v-for="(history, index) in petitionhistory" :key="index">
                        <div class="timeline-icon">
                          <i class="icon IP-tick-sign"></i>
                        </div>
                        <div class="timeline-info">
                          <button class="btn active-green ml-0">
                            {{
                              history.createdByRoleName
                                ? history.createdByRoleName
                                : "Anonymous User"
                            }}
                          </button>
                          <ul>
                            <li>
                              <h3>
                                <span>{{ history.title }}</span>
                                <div
                                  v-if="history.comment && history.comment != ''"
                                  class="title_des"
                                >
                                  <small></small>
                                  <div class="dec-content">
                                    <p> {{ returnCommentText(history.comment) | commentSubString }}</p>
                                    <span v-if="checkCommentLength(history['comment'])" class="view_more" @click="showHistoryComment(history)"> View More</span>
                                  </div>
                                </div>
                              </h3>
                              <span>{{ history.description }}</span>
                              <span>{{ history.createdOn | formatDateTime }}</span>
                              <p class="m-0" v-if="checkProperty(history, 'documents') && checkProperty(history, 'documents', 'length') > 0" >
                                <ul class="activities_doc_list">
                                  <template v-for="(doc,indoc) in history['documents']" >
                                    <template v-if="checkProperty(doc, 'path')">
                                      <li class="cursor-pointer" @click="download_or_view(doc)" >
                                        <docmentType :title="checkProperty(doc, 'name')" :item="doc" />
                                      </li>
                                    </template>
                                  </template>
                                </ul>
                              </p>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </VuePerfectScrollbar>
              </div>
            </div>
          </div>
          <template v-show="getCaseStatusTab === 'showMeetingDetails' && [8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))<=-1">
            <MeetingDetails
              v-if="checkProperty(caseDetails, 'verifierType') === 'remote' && meetingJoined == false" 
              @joinMeeting="joinMeeting" :petitionerWillDo="checkPetitionerWillDo" @editMeeting="editMeeting"  :caseDetails="caseDetails" @cancelMeeting="cancelMeeting"/>
            <videoCallMeeting
              v-if="checkPetitionerWillDo && checkProperty(caseDetails, 'verifierType') === 'remote' && meetingJoined"
              @endVideoCall="endVideoCall" :petitionDetails="caseDetails" :ref="'videoCallMeetingComp'"/>
          </template>
        </vs-col>
      </template>
      <template v-else>
        <!-- && [4,5,6,8,9,10].indexOf(checkProperty(caseDetails, 'statusDetails', 'id'))<=-1 -->
        <vs-col
          vs-type="flex"
          class="padr0 padl0 mob-right activies_list_wrap status_wrap"
          style="width: 350px; flex-direction: column"
          v-if="!loadedFromPreview && (([51,49].indexOf(getUserRoleId) <= -1 && checkCurrentUrl ) || 
          (([49].indexOf(getUserRoleId)>-1 || ([51].indexOf(getUserRoleId)>-1 && (checkProperty(caseDetails, 'verifierDetails','firstName')|| checkIwillDoIt)) ||!checkCurrentUrl) && checkProperty(caseDetails, 'verifierType') === 'remote'))"
        >
          <ul v-if="checkCurrentUrl && !loadedFromPreview && [49,51].indexOf(getUserRoleId) <= -1">
            <li class="ptstatusBar">
              <div class="status_activities">
                <label :class="{ 'active': 'active' }">Activities</label>
              </div>
            </li>
          </ul>
          <div class="history-sidebar petition_history activies_list" v-if="[49,51].indexOf(getUserRoleId) <= -1 && checkCurrentUrl">
            <div class="vs-sidebar">
              <div class="petition_updated" v-if="petitionhistory.length == 0">
                Last Updated -
                {{ checkProperty(caseDetails, "updatedOn") | formatDateTime }}
              </div>
              <div class="petition_updated" v-if="petitionhistory.length > 0">
                Last Updated - {{ petitionhistory[0].createdOn | formatDateTime }}
              </div>

              <div class="vs-sidebar--items">
                <VuePerfectScrollbar class="scroll-area">
                  <div class="timeline-sidebar 2">
                    <ul>
                      <li v-for="(history, index) in petitionhistory" :key="index">
                        <div class="timeline-icon">
                          <i class="icon IP-tick-sign"></i>
                        </div>
                        <div class="timeline-info">
                          <button class="btn active-green ml-0">
                            {{
                              history.createdByRoleName
                                ? history.createdByRoleName
                                : "Anonymous User"
                            }}
                          </button>
                          <ul>
                            <li>
                              <h3>
                                <span>{{ history.title }}</span>
                                <div
                                  v-if="history.comment && history.comment != ''"
                                  class="title_des"
                                >
                                  <small></small>
                                  <div class="dec-content">
                                    <p> {{ returnCommentText(history.comment) | commentSubString }}</p>
                                    <span v-if="checkCommentLength(history['comment'])" class="view_more" @click="showHistoryComment(history)"> View More</span>
                                  </div>
                                </div>
                              </h3>
                              <span>{{ history.description }}</span>
                              <span>{{ history.createdOn | formatDateTime }}</span>
                              <p class="m-0" v-if="checkProperty(history, 'documents') && checkProperty(history, 'documents', 'length') > 0" >
                                <ul class="activities_doc_list">
                                  <template v-for="(doc,indoc) in history['documents']" >
                                    <template v-if="checkProperty(doc, 'path')">
                                      <li class="cursor-pointer" @click="download_or_view(doc)" >
                                        <docmentType :title="checkProperty(doc, 'name')" :item="doc" />
                                      </li>
                                    </template>
                                  </template>
                                </ul>
                              </p>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </VuePerfectScrollbar>
              </div>
            </div>
          </div>
          <MeetingDetails 
          v-if="([49].indexOf(getUserRoleId)>-1 || !checkCurrentUrl  
          || ([51].indexOf(getUserRoleId)>-1 && (checkProperty(caseDetails, 'verifierDetails','firstName')|| checkIwillDoIt )) ) 
          && checkProperty(caseDetails, 'verifierType') === 'remote' && meetingJoined == false" 
          @joinMeeting="joinMeeting" @editMeeting="editMeeting"  :caseDetails="caseDetails" @cancelMeeting="cancelMeeting"/>
          <videoCallMeeting 
          v-if="([49,51].indexOf(getUserRoleId)>-1 || !checkCurrentUrl) 
          && checkProperty(caseDetails, 'verifierType') === 'remote' && meetingJoined"
          @endVideoCall="endVideoCall" :petitionDetails="caseDetails" :ref="'videoCallMeetingComp'"/>
        </vs-col>
      </template>
    
      

      
    </div>
  </div>
 

  </section>
  
  <modal
      name="historyComment"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="800px"
      height="auto"
    >
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Comment</h2>
          <span @click="$modal.hide('historyComment');selectedHistory=null">
            <em class="material-icons">close</em> 
          </span>
        </div>

        <div class="form-container">
                <div class="vx-row mb-2">
                    <div class="vx-col w-full comment_modal">
                        <p style="line-height: 20px" v-html="checkProperty(selectedHistory ,'comment')">
                         
                        </p>
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <vs-button color="dark" class="cancel" type="filled" @click="$modal.hide('historyComment');selectedHistory=null">Cancel</vs-button>
                
            </div>

       
        </div>
  </modal>
  <vs-popup
      class="document_modal document_modal-v2 "
      :class="{ 'expand': expandModal, 'custom_close_doc_modal':showCloseIcon }"
      :title="checkProperty(selectedFile, 'name')"
      :active.sync="docPrivew"
    >
    <div class="document_actions" @click="expandModal = !expandModal">
      <figure v-if="!expandModal" class="maximize-img"><img src="@/assets/images/maximize.png"  width="18" height="18"/></figure>
      <figure v-else class="minimize-img"><img src="@/assets/images/minimize.png"  width="20" height="20"/></figure>
    </div>
    <div class="custom_close" v-if="showCloseIcon">
      <figure class="close_icon" @click="showConfrmLetterPopup = true;updateletterLoading = false;errorMessage=''">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 20"><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z"/></svg>
      </figure>
    </div>
      <h2>
        <img
          :class="{
            pdf_view_download: docType == 'pdf',
            office_view_download: docType == 'office',
            image_view_download: docType == 'image',
          }"
          class="download-button"
          @click="downloads3file(selectedFile)"
          src="@/assets/images/download.svg"
        />
      </h2>
      <div class="pdf_loader">
        <figure v-if="formSubmited && !saveEditedFile" class="loader loader2">
          <img src="@/assets/images/main/loader.gif" />
        </figure>

        <!-- <span :class="{'pdf_view_close':docType == 'pdf', 'office_view_close':docType == 'office'  , 'image_view_close 33':docType =='image'}" class="close close2" @click="docPrivew= false"></span> -->
        <template v-if="docType == 'office'">
          <div style="height: 90vh">
            <div id="placeholder" style="height: 100%"></div>
          </div>
        </template>
        <template v-else-if="docType == 'image'">
          <img :src="docValue" />
        </template>
        <template v-else-if="docType == 'pdf'">
          <div class="pdf" style="height: 90vh">
            <iframe
              v-if="docValue != ''"
              border="0"
              style="border: 0px"
              :src="docValue"
              height="100%"
              width="100%"
            >
            </iframe>
          </div>
        </template>
      </div>
  </vs-popup>
  <assignVerifier v-if="isVerifierAssigned" @closeAssignVerifierPopUp="closeAssignVerifierPopUp" :caseDetails="caseDetails" :isReAssignedToMe="isReAssignedToMe"/>
  <createAuthSignRequest v-if="showAuthSignRequestPopup" @hideAuthSignRequestModal="hideAuthSignRequestModal" :caseDetails="caseDetails" />
  <scheduleMeeting  v-if="showMeeting" @hideMeeting="hideMeeting" :callFromEdit="callFromEditMeeting"
  :i9Id="i9Id" :petitionDetails="caseDetails" />
  <cancelMeeting  v-if="showCancelMeeting" @hideCancelMeeting="hideCancelMeeting"
  :i9Id="i9Id" :petitionDetails="caseDetails" />
  <otpVerification v-if="showVerification"  @resendOtp="sendOtpRequest" :petitionDetails="caseDetails" :otpErrorMsg="otpErrorMsg" :approveType="approveType"  @Hideverification="Hideverification" />
  <auditTrail  v-if="showAuditTrail" :i9Id="i9Id" :caseDetails="caseDetails" @hideAudit="hideAudit"/>
  <commentsPopup  v-if="showCommentPopup" :approveType="approveType" @hideCommentPopup="hideCommentPopup"/>
  <vs-popup class="Change_petition_wrap" v-bind:title="'Confirmation'" :active.sync="reAssignPopUp">
      <div class="Change_petition">
        <div class="vx-col w-full marb10">
          <h3 class="text-left">
            Are you sure you want to continue ?
          </h3>
        </div>
      </div>
      <div class="popup-footer relative">
        <button @click="reAssignPopUp = false" class="cancel" type="filled" color="dark">No</button>
        <button class="save" color="success" type="filled" @click="reAssignverifier()">
          Yes
        </button>
      </div>
</vs-popup>
</template>
</div>
</template>

<script>
import verifierActionInfo from "@/views/i-9Module/verifierActionInfo.vue";
import documentsView from "@/views/common/documentsView.vue";
  import commentsPopup from "@/views/forms/fields/commentsPopup.vue";
import auditTrail from "@/views/i-9Module/auditTrail.vue";
import otpVerification from "@/views/i-9Module/verifierFlow/otpVerification.vue";
import scheduleMeeting from "@/views/i-9Module/verifierFlow/scheduleMeeting.vue";
import cancelMeeting from "@/views/i-9Module/verifierFlow/cancelMeeting.vue";
import MeetingDetails from "@/views/i-9Module/verifierFlow/meetingDetails.vue";
import videoCallMeeting from "@/views/i-9Module/videoCalling/videoCallMeeting.vue";
// import Avatar from 'vue-avatar'
   import createAuthSignRequest from './createAuthSignRequest.vue'
   import assignVerifier from "./assignVerifierModal.vue"
    // import genderField from '@/views/fields/gender.vue'
    import immiInput from "@/views/forms/fields/simpleinput.vue";
    import addressField from "@/views/forms/fields/address.vue";
    import datepickerField from "@/views/forms/fields/datepicker.vue";
    import selectField from "@/views/forms/fields/simpleselect.vue";
    import docType from "@/views/common/docType.vue";
    import EmployeeInformation from "@/views/i-9Module/EmployeeInformation.vue";
   import basicInfo from "@/views/i-9Module/caseDetailsComponents/basicInfo.vue";
   import section2Documents from "@/views/i-9Module/caseDetailsComponents/section2Documents.vue";
   import I9ProcessFlow from "./actionsFlow/i9ProcessFlow.vue";
   import VuePerfectScrollbar from "vue-perfect-scrollbar";
import docmentType from "@/views/common/docType.vue";
import verifierDetails from "@/views/i-9Module/verifierFlow/verifierDetails.vue";

    export default {
      provide() {
          return {
              parentValidator: this.$validator,
          };
      },
      props:{
        loadedFromPreview:{
          type:Boolean,
          default:false
        },
        previewData:null,
      },
      data() {
        return {
          verifiedDocuments:false,
          tenantName:'',
          accessError:'',
          isReAssignedToMe:false,
          reAssignPopUp:false,
          anonymousToken:'',
          formSubmited: false,
          expandModal: false,
          showCommentPopup:false,
          showProcessFlow: false,
          docPrivew: false,
          showCloseIcon:false,
          showConfrmLetterPopup:false,
          docValue: "",
          docType: "",
          selectedFile: null,
          
          showAuditTrail:false,
          otpErrorMsg:'',
          caseInfo:null,
          approveType:null,
          showVerification:false,
          verificationCode:'',
          verificationComment:'',
          showCancelMeeting:false,
          callFromEditMeeting:false,
          showMeeting:false,
          meetingJoined:false,
          petitionhistory:[],
          selectedHistory:'',
          petitions: [],
          showAuthSignRequestPopup:false,
          isVerifierAssigned:false,
          caseDetails:null,
          i9Id:null,
          address: {
            line1: null,
            line2: null,
            aptType: null,
            locationId: null,
            locationDetails: null,
            stateId: null,
            stateDetails: null,
            countryId: null,
            countryDetails: null,
            zipcode: null,
          },
          countries: [
            { id: 231, name: 'USA' }, 
          ],
          optionslist: [
            { 1: 231, name: 'USA' }, 
          ],
          selectedTab: 'Basic Info',  
        }
      },
      computed:{
        checkIwillDoIt(){
          let returnVal = false;
          if(this.checkProperty(this.caseDetails, 'chooseVerifyAndSign') && this.checkProperty(this.caseDetails, 'authroizedRepresent') === false){
            returnVal = true;
          }
          return returnVal;
        },
        // commented
        getConfirmation(){
                let returnVal = '';
                if(this.verifiedDocuments ){
                    returnVal = 'returnVal';
                }
                return returnVal;
            },
        checkPetitionerWillDo(){
          let returnVal = false;
          // console.log(this.checkProperty(this.getUserData, 'email'))
          // console.log(this.checkProperty(this.caseDetails, 'verifierInfo', 'email'))
          // console.log(this.checkProperty(this.getUserData, 'email') === this.checkProperty(this.caseDetails, 'verifierInfo', 'email'))
          if(this.checkProperty(this.caseDetails, 'chooseVerifyAndSign') && !this.checkProperty(this.caseDetails, 'authroizedRepresent') && (this.checkProperty(this.getUserData, 'email') === this.checkProperty(this.caseDetails, 'verifierInfo', 'email'))){
            returnVal = true;
          }
          return returnVal;
        },
        checkCommentLength(){
          return (comment='')=>{
            let textcomment = comment;
            let self = this;
            let returnVal = false;
            if(textcomment){
              var plainText = textcomment.replace(/<[^>]*>/g, '');
              let plainext = plainText.replace(/&nbsp;|&nbsp/g, ' ');
              if(plainext){
                var htmlString = plainext.trim();
                if(htmlString && self.checkProperty(htmlString, 'length') > 100 ){
                  returnVal = true
                }
              }
            }
            return returnVal
          }
        },
        returnCommentText(){
          return (comment='')=>{
            let returnVal = '';
            if(comment){
              var plainText = comment.replace(/<[^>]*>/g, ' ');
              let plainext = plainText.replace(/&nbsp;|&nbsp/g, ' ');
              if(plainext){
                returnVal = plainext.trim();
                
              }
            }
            return returnVal
          }
        },
    
    checkActionsPermissions(){
      let returnVal = false;
       //Show Action Approve/Reject.
       if((([50].indexOf(this.getUserRoleId)>-1&&this.getTenantTypeId != 2)||(this.getTenantTypeId == 2&&[3,4].indexOf(this.getUserRoleId)>-1))&&(this.checkProperty(this.caseDetails, 'completedActivities', 'length') > 0
      && this.caseDetails.completedActivities.indexOf('APPROVED') <= -1 && (this.caseDetails.completedActivities.indexOf('REJECTED') <= -1 || [10].indexOf(this.checkProperty(this.caseDetails, 'statusDetails', 'id'))<=-1)
       &&((this.caseDetails.completedActivities.indexOf('WAITING_FOR_EMPLOYEE_SIGN') >-1||this.checkProperty(this.caseDetails, 'questionnaireFilled'))&&this.checkProperty(this.caseDetails, 'statusDetails', 'id') > 3 ))
      ||((([50].indexOf(this.getUserRoleId)>-1&&this.getTenantTypeId != 2)||(this.getTenantTypeId == 2&&[3,4].indexOf(this.getUserRoleId)>-1)) &&(this.checkProperty(this.caseDetails, 'completedActivities', 'length') > 0 && this.caseDetails.completedActivities.indexOf('VERIFIER_REJECTED') >-1 && [4].indexOf(this.checkProperty(this.caseDetails, 'statusDetails', 'id'))>-1))){
        returnVal = true;
        return returnVal;
      }
      //Show Action EditQuestionnarie.
      if([51].indexOf(this.getUserRoleId)>-1&& 
      (!this.checkProperty(this.caseDetails, 'questionnaireFilled') 
      || (this.checkProperty(this.caseDetails, 'questionnaireFilled') && (this.checkProperty(this.caseDetails, 'completedActivities', 'length') > 0 && this.caseDetails.completedActivities.indexOf('REJECTED') >-1 || this.checkProperty(this.caseDetails, 'completedActivities', 'length') > 0 && this.caseDetails.completedActivities.indexOf('VERIFIER_REJECTED')>-1)) && this.checkProperty(this.caseDetails, 'statusDetails', 'id') == 10)){
        returnVal = true;
        return returnVal;
      }

      // if([3,4,5,6,8,7].indexOf(this.getUserRoleId)>-1  && 
      // ([9].indexOf(this.checkProperty(this.caseDetails, 'statusDetails', 'id'))>-1)){
      //    returnVal = true ;
      //    return returnVal
      // }
      
      return returnVal;
    },
    

  },
      watch: {
        $route: function () {
          if (this.$route.params && this.$route.params.itemId) {
            this.i9Id = this.$route.params.itemId;
          }
        },
      },
      mounted() {
        if([50].indexOf(this.getUserRoleId)>-1 || ([3,4,5,6,7,8].indexOf(this.getUserRoleId)>-1 && this.getTenantTypeId==2)){
          this.$store.commit('toggleCaseStatusTab', 'showActivities')
        }
        this.getGlobalConfigDetails()
        if (this.$route.params && this.$route.params.itemId) {
          this.i9Id = this.$route.params.itemId;
        }
        if((this.$route.params && this.$route.params.joinMeet && this.$route.params.joinMeet ==='join') || 
        (this.$route.query && this.$route.query.joinMeet && this.$route.query.joinMeet ==='join')){
          setTimeout(()=>{
            this.checkMeetingJoin();
          },1000)
        }
        if((this.$route.params && this.$route.params.assign && this.$route.params.assign ==='assign_verifier')){
          setTimeout(()=>{
            this.$refs['basic_info'].triggerAssignVerifer()
            // this.assignVerifier();
          },6500)
        }
        if(this.loadedFromPreview && this.previewData){
          this.caseDetails = _.cloneDeep(this.previewData)
        }else{
          this.getCaseDetails();
          this.updateAnonymus();
        }
      },
      methods: {
        reAssignverifier(){
          let path = '/i9/reassign-verifier'
          let postData={
            'i9Id':this.checkProperty(this.caseDetails, '_id')
          }
          this.$store.dispatch("commonAction", {data:postData,path:path})
          .then((response) =>{ 
            this.showToster({ message: response.message, isError: false });
            this.reAssignPopUp=false
            this.getCaseDetails();
          }).catch((eer)=>{
            this.showToster({ message:eer , isError: true})
          })

        },
        reAssign(){
          this.reAssignPopUp=true
        },
        reAssignToMe(){
          this.isReAssignedToMe = true
          this.assignVerifier()
        },
        editVerifier(){
          this.isReAssignedToMe=false
          this.assignVerifier()
        },
        editAuthSign(){
          this.requestAuthSign()
        },
        showHistoryComment(item=null){
          this.selectedHistory = item;
          if(this.checkProperty(this.selectedHistory ,'comment')){
            this.$modal.show('historyComment');
          }else{
            this.$modal.hide('historyComment');
          }

        },
        getGlobalConfigDetails(){
          let postData ={}
          let path = 'global-config/details'
          this.$store.dispatch("commonAction", {data:postData,path:path})
          .then((response) =>{ 
               if(response&&response.config&&!response.config.enableI9Requests){
                this.$router.push('/error-404')
               }
          }).catch((eer)=>{
           
          })
        },
        checkMeetingJoin(){
          let curRoute = this.$route;
            if(curRoute){
              let routeName = curRoute.name
              if((curRoute.params && curRoute.params.joinMeet && curRoute.params.joinMeet ==='join')||
              (curRoute.query && curRoute.query.joinMeet && curRoute.query.joinMeet ==='join')){
                let self = this;
                setTimeout(()=>{
                  self.joinMeeting();
                  // self.$router.replace({ path: this.$route.path, query: { joinMeet: '' } })
                  //self.$router.replace({ name: routeName, params: { itemId: this.i9Id }});
                  // const query = { ...self.$route.query, 'joinMeet': '' };
                  // self.$router.replace({ path: self.$route.path, query });
                  //self.$router.replace({ query:{joinMeet:false } });
                  //  self.$router.push({ name: routeName, params: { itemId: this.i9Id }}).catch(err => {})
                  console.log('joined')
                },1500)
              }
            }
        },
        hideCommentPopup(callFromSubmit = false, data = ''){
          if(data){
              this.verificationComment = data;
          }
          if(callFromSubmit){
            this.approveCase(this.approveType)
          }
          this.showCommentPopup = false;
        },
        getVerifierActions() {
        if(this.petitionhistory.length > 0){  
        let filteredActions = this.petitionhistory.filter(action =>
          action.title === 'I-9 form is rejected - Verifier' || action.title === 'I-9 form is approved - Verifier'
        );
        // if(filteredActions.length > 0){
        //   this.caseInfo.push(filteredActions)
        //   console.log(this.caseInfo)
        // }

        if (filteredActions.length > 0) {
          let latestAction = filteredActions.reduce((latest, action) =>
            new Date(action.createdOn) > new Date(latest.createdOn) ? action : latest
          );
          this.caseInfo = latestAction
          // this.caseInfo.push(latestAction)
          // return latestAction.title === 'I9_FORM_REJECTEDI-9 form is rejected - Verifier' || latestAction.title === 'I-9 form is approved - Verifier';
        }
        // console.log(this.caseInfo)
        return false;
      }
      },
      download_or_view(docItem) {
      let value = _.cloneDeep(docItem);
      this.selectedFileForEdit =false;
      this.showCloseIcon = false;
      if ( _.has(value ,'viewmode') && this.checkProperty(value,'viewmode')==false ) {
          this.selectedFileForEdit =true;
      }

      this.expandModal= false;

      if (
        this.checkProperty(this.getPetitionDetails, "caseNo") &&
        this.checkProperty(value, "name")
      ) {
        let docName = _.cloneDeep(value["name"]);
        
        try{
          if(!docName.includes(this.checkProperty(this.getPetitionDetails, "caseNo"))){
            value["name"] = docName;
          }
        }catch(err){

        }

        
      }

      var _self = this;
      this.formSubmited = false;
      if (_.has(value, "path")) {
        value["url"] = value["path"];
        value["document"] = value["path"];
      }

      if (_.has(value, "url")) {
        value["path"] = value["url"];
        value["document"] = value["url"];
      }

      if (_.has(value, "document")) {
        value["path"] = value["document"];
        value["url"] = value["document"];
      }

      this.selectedFile = value;
      this.docValue = "";
      this.docPrivew = false;
      this.docType = false;
      this.docType = this.findmsDoctype(value);
      this.showCloseIcon = false;

      //if ( (this.docType == "office" || this.docType == "image" || this.docType == "pdf") && value.download == false ) {
      if (this.docType == "office" || this.docType == "image" || this.docType == "pdf") {
        value.url = value.url.replace(this.$globalgonfig._S3URL, "");
        value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
        let postdata = {
          keyName: value.url,
          petitionId: value["petitionId"],
        };
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          this.docValue = response.data.result.data;

          if (this.docType == "office") {
            document.getElementById("placeholder").innerHTML =
              "  <div  id='placeholder2' style='height:100%'></div>";
            let _editing = false;

            if ([50, 51].indexOf(this.getUserRoleId) > -1) {
              _editing = false;
            }
           
            let docViewUrl ='https://immibox.com/api/petition/post-edited-document';
            if(_.has(this.$globalgonfig, 'DOC_VIEW_URL')){
              docViewUrl = this.$globalgonfig['DOC_VIEW_URL'];
            }

            let entityId = 'cover_letter';
            if(this.checkProperty(value,'entityId')){
              entityId = value['entityId'];
            }
               
            if ( _.has(value ,'viewmode') && value.viewmode==false ) {
              _editing = true;
              if(_.has(value,'type') && _self.checkProperty(value, 'type') == 'Letter' && _.has(value,'generated') &&
              (_self.checkProperty(value, 'generated') == true || _self.checkProperty(value, 'generated') == 'true') && !value['parentId'] 
               ){
                //&& !value['parentId'] removed parentId in above condition as per requirement
                this.showCloseIcon = true; 
                // && this.checkProperty( this.$store.state ,'selectedForEditDocument') && this.checkProperty( this.$store.state ,'selectedForEditDocument', 'savedDocumentId')
              } 
            }
            var _ob = {};
            if (value.editedDocument) {
              _ob = {
               // entityId:entityId,
                petitionId: this.checkProperty(this.caseDetails, '_id'),
                name: value.name,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value.parentId,
              };
            } else {
              _ob = {
               // entityId:entityId,
                name: value.name,
                petitionId: this.checkProperty(this.caseDetails, '_id'),
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value._id,
              };
            }
            var nid = value._id +  Math.round(+new Date()/1000)
            window.docEditor = new DocsAPI.DocEditor("placeholder2", {
              document: {
                c: "forcesave",
                fileType: "docx",
                key: nid,
                userdata: JSON.stringify(_ob),
                title: value.name,
                url: response.data.result.data,
                permissions: {
                  edit: _editing,
                  download: true,
                  reader: false,
                  review: false,
                  comment: false,
                },
              },

              documentType: "word",
              height: "100%",
              width: "100%",

              editorConfig: {
                userdata: JSON.stringify(_ob),
                callbackUrl:
                docViewUrl+"?entityId="+entityId+"&payload=" +
                  JSON.stringify(_ob) +
                  "&token=" +
                  _self.$store.state.token +
                  "&name=" +
                  value.name.replace(".docx", ""),
                customization: {
                  logo: {
                    image: "https://immibox.com/app/favicon.png",
                    imageDark: "https://immibox.com/app/favicon.png",
                    url: "https://immibox.com",
                  },
                  anonymous: {
                    request: false,
                    label: "Guest",
                  },
                  chat: false,
                  comments: false,
                  compactHeader: false,
                  compactToolbar: true,
                  compatibleFeatures: false,
                  feedback: {
                    visible: false,
                  },
                  forcesave: true,
                  help: false,
                  hideNotes: true,
                  hideRightMenu: true,
                  hideRulers: true,
                  layout: {
                    toolbar: {
                      collaboration: false,
                    },
                  },
                  macros: false,
                  macrosMode: "warn",
                  mentionShare: false,
                  plugins: false,
                  spellcheck: false,
                  toolbarHideFileName: true,
                  toolbarNoTabs: true,
                  uiTheme: "theme-light",
                  unit: "cm",
                  zoom: 100,
                },
              },
              events: {
                onReady: function () {},
                onDocumentStateChange: function (event) {
                  var url = event.data;
                  if (!event.data) {
                    if (value.editedDocument) {
                    }
                  }
                },
              },
            });
            //this.docValue = encodeURIComponent(response.data.result.data);
          }

          if (this.docType == "pdf") {
            var formAndLetterId = value._id;
            let parentId = '';
            // if (this.checkProperty(value,'parentId')) {
            //   parentId = value.parentId;
            // }
            //else{
            //   if (this.checkProperty(value,'generated')) {
            //     parentId = value._id;
            //   }
             
            // }
            //alert(parentId)
            var  viewmode = 0; //viewmode= 1 Enable edit AND viewmode= 0; //Disabled Edit
            let pdfViewUrl ='https://immibox.com/viewer/pdfjs-dist/web/viewerv2.html';
            
            if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
              pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
            }
             

            if(_.has(value ,'viewmode')){
              if (value.viewmode) {
                viewmode = 0;
              }else{
                viewmode = 1;
                viewmode=viewmode+"&depLabel="+value.depLabel+"&depType="+value.depType+"&docUserType="+value.docUserType+"&generated="+value.generated+"&parentId="+parentId+"&formAndLetterId="+formAndLetterId+"&save=v2&docname="+value.name+"&posturl="+this.$globalgonfig._APIURL+"/&petitionId="+this.$route.params.itemId+"&entityId="+value.entityId+"&token="+this.$store.state.token
                if(_.has(this.$globalgonfig, 'PDF_EDIT_URL')){
                  pdfViewUrl = this.$globalgonfig['PDF_EDIT_URL'];
                  
                 }
              }

            }

           
            
           
            if(this.getPetitionTab != 'Forms and Letters'){
              viewmode= 0; //Disabled Edit
              if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
                pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
              }
              
            }
           
            this.docValue =
            pdfViewUrl+"?view=" +
              viewmode +
              "+&file=" +
              encodeURIComponent(response.data.result.data);
          }
          this.docPrivew = true;
        });
      } else {
        this.downloads3file(value);
      }
    },
        openAuditTrail(){
          this.showAuditTrail = true;
        },
        hideAudit(){
          this.showAuditTrail = false;
        },
        sendOtpRequest(){
          let payLoad={
              i9Id:this.i9Id,
              action:this.approveType
          };
          let path = '/i9/send-otp';
          this.$store.dispatch('commonAction', {data:payLoad, 'path':path}).then((res)=>{}).catch((err)=>{})
        },
        checkApprvOrReject(app){
          this.$validator.validateAll("Documentsform").then((result) => {
            if(result){
          if(!this.checkCurrentUrl){
            this.otpErrorMsg = '';
            this.approveType = app;
            this.sendOtpRequest();
            this.showVerification = true;
            this.verificationCode = '';
            this.verificationComment = '';
          }else {
            this.approveType = app;
            this.showCommentPopup = true;
            this.verificationComment = '';
          }
        } 
      }) 
          // else{ if(this.checkProperty(this.petitionDetails, 'verifierType') === 'physical')
          //   this.approveCase(app);
          // }
        },
        Hideverification(callFromSubmit = false, data = '', hidepopup = true, commentDat=''){
          this.otpErrorMsg = '';
          if(data){
              this.verificationCode = data;
          }
          if(hidepopup){
              this.showVerification = false;
          }
          if(callFromSubmit){
            this.approveCase(this.approveType)
          }
          if(commentDat){
            this.verificationComment = commentDat
          }
        },
        approveCase(approve){
          let payLoad = {
            i9Id:this.i9Id,
            verifierType:this.checkProperty(this.caseDetails, 'verifierType'),
            verifierApprOrReject:approve,
            verifierApproved:([49].indexOf(this.getUserRoleId)>-1 || !this.checkCurrentUrl)?true:false,
            anonymous:!this.checkCurrentUrl?true:false
          }
          if(!this.checkCurrentUrl){
            payLoad['code'] = this.verificationCode;
          }
          payLoad['comment'] = this.verificationComment
          let path = '/i9/verifier-approve-or-reject'
          this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
            this.showVerification = false;
            this.showToster({message:res.message,isError:false });

            this.getCaseDetails();
          }).catch((err)=>{
            
            if(err == 'Invalid OTP'){
              this.otpErrorMsg = _.cloneDeep(err);
            }
          })
        },
        hideCancelMeeting(){
          this.showCancelMeeting = false;
          this.getCaseDetails();
        },
        cancelMeeting(){
          this.meetingJoined = false;
          this.showMeeting = false; 
          this.callFromEditMeeting = false;
          this.showCancelMeeting = true;
        },
        editMeeting(schedule = false){
          this.meetingJoined = false;
          this.showCancelMeeting = false;
          this.showMeeting = true; 
          if(schedule == false){
            this.callFromEditMeeting = true;
          }
          // this.callFromEditMeeting = true;
        },
        hideMeeting(){
          this.showMeeting = false; 
          this.callFromEditMeeting = false;
          this.getCaseDetails()
        },
        joinMeeting(){
          let self  = this;
          this.meetingJoined = true;
          setTimeout(()=>{
            if(self.meetingJoined){
              self.$refs['videoCallMeetingComp'].checkCallStatus(); //toggleCamera ,checkCallStatus checkConsole
            }
          })
          
        },
        endVideoCall(){
          this.meetingJoined = false;
          if(this.$route.params && this.$route.params.joinMeet && this.$route.params.joinMeet ==='join'){
            this.$router.push({ name: 'i9-details', params: { itemId: this.i9Id, joinMeet:'' } })
          } 
          if(this.$route.query && this.$route.query.joinMeet && this.$route.query.joinMeet ==='join' && this.anonymousToken){
            const path = `/filled-i9-details/${this.i9Id}`;
            this.$router.push({
                path,
                query: {
                    token: this.anonymousToken,
                    joinMeet:''
                }
            })
          }
          this.getCaseDetails(false)
        },
        getcaseHistory(i9Id='') {
          let postData= {
            "i9Id": i9Id,
            "page": 1,
		        "perpage": 10000
          }
          let path="i9/activity-list"
          this.petitionhistory= []
          this.$store.dispatch('commonAction', {data:postData, path:path})
          .then(response=>{
            this.petitionhistory = response.list
            if(this.petitionhistory){
              this.getVerifierActions()
            }
          }).catch((error)=>{
            this.petitionhistory = []       
          })
    },
        showDetails(item){
          if(item&&item._id){
            this.$router.push({ path: `/i9-details/${item._id}`, }).catch(err => {})
          }
          
        },
        reloadPetition(){
          this.getCaseDetails()
        },  
        reloadDetails(){
          this.getCaseDetails()
        },
        hideAuthSignRequestModal(){
          this.getCaseDetails()
          this.showAuthSignRequestPopup=false
        },
        requestAuthSign(){
          this.showAuthSignRequestPopup=true
        },
        closeAssignVerifierPopUp(){
          this.getCaseDetails()
          this.isVerifierAssigned =false
        },
        assignVerifier(){
          this.isVerifierAssigned =true
        },
        goToQuestionaireLink(routeId){
          this.$router.push("/questionnaire/"+routeId);
        },
        openActionPopup(){},
        editQuestionnaire(){ 
          this.$router.push("/I9-questionnaire/"+this.i9Id);
        },
        setCurrentTab(tab) {
          this.selectedTab = tab;
        },
        getCaseDetails(showApprove = false){
          this.callFromEditMeeting = false;
          let postData= {
            "i9Id": this.i9Id
          }
          let path="i9/details"
          this.caseDetails= null
          this.accessError = '';
          this.$vs.loading();
          this.$store.dispatch('commonActionWithErrorData', {data:postData, path:path})
          .then(response=>{
            if(response){
              if(showApprove){
                this.meetingJoined = true;
              }
              
              this.$vs.loading.close();
              this.caseDetails= _.cloneDeep(response);
              if(([49].indexOf(this.getUserRoleId)>-1|| !this.checkCurrentUrl) && this.checkProperty(this.caseDetails, 'veriDetailsUpdate') === false){
                this.$router.push({ path: `/verifier-info/${this.i9Id}`, })
                
              }
              this.getcaseHistory(this.i9Id)
            }else{
                this.showToster({message:"Case Details are not found",isError:true });
                setTimeout(() => {
                  this.$router.push("/dashboard");
                }, 10);
                return true;
            }
           
           //this.caseDetails= null
          }).catch((error)=>{
            if(this.checkProperty(error, 'code')){
              this.accessError = this.checkProperty(error, 'message');
              this.tenantName = this.checkProperty(error, 'tenantName');
            }
            this.caseDetails= null
            this.$vs.loading.close();
          })
        },
        updateAnonymus(){
          let currentRoute = this.$route;
          let token = '';
          if(_.get(currentRoute, "name", "") == "i9/fill-verifier-info" &&  _.has(currentRoute, "meta.getTokenFromUrl") && _.has(currentRoute, "query.token") ) {
            token = _.get(currentRoute, "query.token", "");
            this.anonymousToken = token
            if(token){
              let payLoad = { apiToken:token };
              let path = '/auth/verify-token';
              this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((res)=>{
                if(res){
                    this.$store.commit('updateAnonymousUserData', res)
                }
              }).catch((err)=>{})
            }
          }
        }
      },
      components: {
        verifierActionInfo,
        documentsView,
        commentsPopup,
        auditTrail,
        otpVerification,
        scheduleMeeting,
        cancelMeeting,
        MeetingDetails,
        videoCallMeeting,
        verifierDetails,
        docmentType,
        VuePerfectScrollbar,
        // Avatar,
        I9ProcessFlow,
        createAuthSignRequest,
        assignVerifier,
        section2Documents,
        basicInfo,
       // genderField,
        immiInput,
        addressField,
        datepickerField,
        EmployeeInformation,
        docType
      }
    }
</script>
